import React from 'react';
import { View } from 'react-native';
import { rem, SettingsSection } from 'design-system';
import { SettingsItem } from 'design-system/SettingsItem';
import IconCheck from 'design-system/icons/IconCheck';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useUserAddress } from 'hooks/useUserAddress';
import createStyleSheets from 'utils/createStyleSheets';
const normalize = (value) => value.replace(/\W+/g, '').toLowerCase();
const splitTokens = (value) => value
    .toLowerCase()
    .split(/\W+/)
    .filter((token) => token.length > 1);
const addressesMatch = (emma, accountHolderAddress) => {
    const haystack = normalize(accountHolderAddress);
    if (!haystack)
        return false;
    const postcode = normalize(emma.postcode || '');
    if (!postcode || !haystack.includes(postcode))
        return false;
    const streetTokens = splitTokens(emma.streetName || '');
    if (streetTokens.length === 0)
        return false;
    return streetTokens.every((token) => haystack.includes(token));
};
const buildSubtitle = (emma) => {
    const { buildingNumber, streetName, buildingName, subBuildingName } = emma;
    const parts = [
        subBuildingName,
        buildingName,
        [buildingNumber, streetName].filter(Boolean).join(' '),
    ].filter((part) => !!part && part.length > 0);
    return parts.join(', ');
};
const CreditReportAddressMatchItem = React.memo(({ accountHolderAddress }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const { primaryAddress } = useUserAddress(true);
    if (!primaryAddress || !accountHolderAddress)
        return null;
    if (!addressesMatch(primaryAddress, accountHolderAddress))
        return null;
    const subtitle = buildSubtitle(primaryAddress);
    return (<SettingsSection name="Personal information">
        <SettingsItem title="Address matches the one on your Emma account" description={subtitle || undefined} icon={<View style={styles.checkIcon}>
              <IconCheck thick color={colors.elements.statusPositive}/>
            </View>}/>
      </SettingsSection>);
});
const styleSet = createStyleSheets(() => ({
    checkIcon: {
        marginTop: rem(2),
    },
}));
export default CreditReportAddressMatchItem;
